module.exports = __webpack_public_path__ + "52fc745630c3b1d19bf92ad9d639e834.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/icons/spinnericon/spinnericon.ttf?39661457
// module id = 456
// module chunks = 0